import React, { useState } from 'react'

import { Articles } from './Articles'
import { Writers } from '../Writers/Writers'
import { AllCategories } from './AllCategories'
import { sortPagination } from '../Pagination/Pagination'
import { FoundersClub } from '../FoundersClub/FoundersClub'

import './categoryArchive.scss'

export const CategoryArchive = ({
  category,
  posts,
  isBlogg = false,
  showBloggInAllCategory = false,
  hideMore = false,
  authorName,
  showFoundersClub = true,
  adplacement = null,
}) => {
  const [page, setPage] = useState(1)

  const paginationData = sortPagination(posts, 10, page)

  const area =
    category?.slug === 'kronika' || category?.slug === 'bloggar'
      ? 'byggframtid'
      : null

  return (
    <>
      <div className="innerContainer category-container">
        <Articles
          title={category?.name}
          posts={paginationData?.data}
          totalPages={paginationData?.pages}
          page={page}
          setPage={setPage}
          showPagination
          adplacement={adplacement}
        />
      </div>

      {!hideMore &&
        (isBlogg ? (
          <Writers title="Fler bloggar" authorName={authorName} />
        ) : (
          <div className="bottom-72px">
            <AllCategories
              activeSlug={category?.slug}
              showBlogg={showBloggInAllCategory}
            />
          </div>
        ))}

      {showFoundersClub && <FoundersClub area={area} />}
    </>
  )
}
